export const FETCH_VIDEOS = 'FETCH_VIDEOS';
export const SET_VIDEOS = 'SET_VIDEOS';
export const FETCH_VIDEO = 'FETCH_VIDEO';
export const SET_VIDEO = 'SET_VIDEO';
export const SAVE_VIDEO = 'SAVE_VIDEO';
export const SAVE_VIDEO_FILE = 'SAVE_VIDEO_FILE';
export const SAVE_SUBTITLE = 'SAVE_SUBTITLE';
export const DELETE_VIDEO = 'DELETE_VIDEO';
